import React, { useState } from 'react'
import { number, shape, func, string } from 'prop-types'
import { ZoomIn, ZoomOut } from '@assets/icons'
import { ZoomMinus, ZoomPlus, ZoomWrapper } from './ZoomButtons.style'

export const MAX_MAP_ZOOM = 22
export const MIN_MAP_ZOOM = 0

function ZoomButtons({ initialZoom, map, zoomInIcon, zoomOutIcon }) {
  const [zoom, setZoom] = useState(initialZoom)

  const handleZoom = action => {
    if (!map) return

    const newZoom =
      action === 'plus'
        ? Math.min(zoom + 1, MAX_MAP_ZOOM)
        : Math.max(zoom - 1, MIN_MAP_ZOOM)

    setZoom(newZoom)

    map.setZoom(newZoom)
  }

  return (
    <ZoomWrapper>
      <ZoomPlus onClick={() => handleZoom('plus')}>
        <img src={zoomInIcon || ZoomIn} alt="Zoom in" />
      </ZoomPlus>
      <ZoomMinus onClick={() => handleZoom('minus')}>
        <img src={zoomOutIcon || ZoomOut} alt="Zoom out" />
      </ZoomMinus>
    </ZoomWrapper>
  )
}

ZoomButtons.propTypes = {
  initialZoom: number,
  map: shape({
    setZoom: func,
  }),
  zoomInIcon: string,
  zoomOutIcon: string,
}

ZoomButtons.defaultProps = {
  initialZoom: 15,
  map: null,
  zoomOutIcon: '',
  zoomInIcon: '',
}

export default ZoomButtons
